







import { Component, Vue } from 'vue-property-decorator'
import ArrowBackIcon from 'vue-material-design-icons/ArrowLeftBold.vue'
import VButton from '@/components/VButton.vue'

@Component({ components: { ArrowBackIcon, VButton } })
export default class VBackButton extends Vue {
}

